/* global define APP_CONFIG */
import moment from 'moment';

export const refreshMiddleware = (({ dispatch, getState }) => {
  return (next) => (action) => {

    return next(action);
  };
});
